<template>
    <div>
        <div>
            <el-card>

                <!-- <div slot="header">
                    <el-button type="success" @click='getDefData'>默认</el-button>
                </div> -->
                <el-tabs v-model="envTableValue" type="card">
                    <el-tab-pane
                        v-for="item in envTable"
                        :key="item.name"
                        :label="item.title"
                        :name="item.name"
                    >

                        <el-form ref="form" :model="form" label-width="100px">
                            <!-- 参数 -->
                            <el-row>
                                <el-col>
                                    <el-form-item label="参数">
                                        <el-card>
                                            <div slot="header">
                                                <el-button type='success' @click='addParams'>新增</el-button>
                                            </div>

                                            <el-table :data="item.content" border>

                                                <el-table-column label="属性名" prop="cname"></el-table-column>

                                                <el-table-column label="属性值" prop="value" :formatter='formatter'>
                                                    <template slot-scope="{ row }">
                                                        <a-fold :valueStr='row.value' ></a-fold>
                                                    </template>
                                                </el-table-column>

                                                <el-table-column label="操作" width="150px">
                                                    <template slot-scope="scope">
                                                        <el-button type="text" @click='editParams(scope.row)'>编辑</el-button>
                                                        <el-button class="table-del-btn" type="text" @click="handleDel(scope.$index, item.content)">删除</el-button>
                                                    </template>
                                                </el-table-column>

                                            </el-table>
                                        </el-card>

                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <!-- 服务器 -->
                            <el-row>
                                <el-col>
                                    <el-form-item label="服务器">

                                        <el-select
                                            v-model="form.server"
                                            :remote-method="(query) => remoteServer(query, envTableValue)"
                                            :loading="loading"
                                            clearable
                                            filterable
                                            remote
                                            placeholder="请输入主机名进行搜索"
                                        >
                                            <el-option v-for="item in listAll.server_list" :key="item.value" :label="item.label" :value="item.value"/>
                                        </el-select>

                                        <el-button type='success' @click='AddServer'>新增</el-button>

                                        <el-table :data="item.server" border v-loading='loading' style='margin-top: 40px;'>

                                            <el-table-column label="序列" type="index" width="50"></el-table-column>

                                            <el-table-column label="IP" prop='ip'></el-table-column>

                                            <el-table-column label="Name" prop='hostname'></el-table-column>

                                            <el-table-column label="服务器环境" prop='env'>
                                                <template slot-scope="{ row }">
                                                    {{ tableVal(row.env,env) }}
                                                </template>
                                            </el-table-column>

                                            <el-table-column label="服务器状态">
                                                <template slot-scope="{ row }">
                                                    {{ tableVal(row.status,serverStatus) }}
                                                </template>
                                            </el-table-column>

                                            <el-table-column label="所属组/部门" prop='ci_group'>
                                                <template slot-scope="{ row }">
                                                    <el-input type='text' v-model="row.ci_group" @change="changeCiGroup"></el-input>
                                                </template>
                                            </el-table-column>

                                            <el-table-column label="操作">
                                                <template slot-scope='scope'>
                                                    <!-- <el-button type="text" @click="editService(scope.row)">编辑</el-button> -->
                                                    <el-button class="table-del-btn" type="text" @click="handleDel(scope.$index, item.server)">删除</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>

                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>

                    </el-tab-pane>
                </el-tabs>

                <el-button @click="SubmitBtn" type="primary">确定</el-button>
                <el-button type="primary" @click='getDefData'>默认</el-button>

            </el-card>

        </div>
    </div>
</template>

<script>
    import services from '../cicd.services'
    import AFold from '../../common/aFold'

    export default {
        components: { AFold },

        props: {
            parentType: String
        },

        data() {
            return {
                envTable: [],
                envTableValue: '',
                server: '',
                loading: false,
                listAll: {
                    server_list: []
                },
                serverList: [],
                form: {

                },
                paramsTag: false,
                serviceTag: false
            };
        },

        watch: {
            envTable: {
                handler(newval, oldval) {
                    if(!oldval.length) this.envTableValue = newval[0].name
                },

            }
        },

        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            env() {
                return this.dictionary.env
            },
            serverStatus() {
                return this.dictionary.server_status
            },
            defuseParams() {
                return this.$store.state.defuseParams
            },
            useParams() {
                return this.deepCopy(this.$store.state.useParams)
            },
    //         useParams:{
    //             get:function () {
    //                 return this.$store.state.useParams
    //             },
    //             set:function (newVal) {
    //                 console.log(newVal,'newVal');
    //                 // this.$store.commit('setUseParams', newVal)
    //             }
    // }
        },

        created() {
            this.getData(this.useParams)
        },

        methods: {
            // 深拷贝
            deepCopy(obj) {
                let result = Array.isArray(obj) ? [] : {};
                for (let key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        if (typeof obj[key] === 'object' && obj[key]!==null) {
                            result[key] = this.deepCopy(obj[key]);   //递归复制
                        } else {
                            result[key] = obj[key];
                        }
                    }
                }
                return result;
            },
            //修改过ci-group的input框内容
            changeCiGroup(){
                this.serviceTag=true
            },
            // 添加参数
            addParams() {
                this.paramsTag = true
                this.$router.push({
                    path: '/paramsAdd',
                    query: {
                        ind: this.envTableValue,
                        parentType: this.parentType,
                        callback: this.changeData,
                        envId: this.envTableValue,

                    }
                })
            },

            // 编辑参数
            editParams(row) {
                this.paramsTag = true
                this.$router.push({
                    path: '/paramsAdd',
                    query: {
                        type: 'edit',
                        envId: this.envTableValue,
                        keys: JSON.stringify(row),
                        values: row.value,
                        parentType: this.parentType,
                        callback: this.changeData
                    }
                })
            },

            // 添加服务器
            AddServer() {
                this.serviceTag = true
                if (this.form.server) {
                    let obj = JSON.parse(this.form.server)
                    obj = {
                        ...obj,
                        env: this.envTableValue
                    }

                    this.envTable = this.envTable.map(item => {
                        if (item.name === this.envTableValue) {
                            return {
                                ...item,
                                server: this.filterServer(obj, item.server)
                            }
                        } else {
                            return item
                        }
                    })
                    this.form.server = ''
                }
            },

            // 筛选服务器并且添加
            filterServer(serverObj, serverArr) {
                let isUseServer = serverArr.filter(item => item.id === serverObj.id)
                !isUseServer.length && serverArr.unshift(serverObj)
                return serverArr
            },

            // 搜索服务器
            remoteServer(query, val) {
                if (query !== '') {
                    this.loading = true
                    services.filterServer(query)
                        .then(res => {
                            this.listAll.server_list = Object.keys(res.server_data).map(item => {
                                return { value: JSON.stringify(res.server_data[item]), label: "主机名:" + item + " --- IP: ("+ res.server_data[item].ip +") " }
                            })
                            this.loading = false
                        })
                } else {
                    this.listAll.server_list = []
                }
            },

            // 获取默认数据
            getDefData() {
                this.$store.commit('setUseParams', this.defuseParams)
                this.getData(this.defuseParams)
            },

            // 获取数据
            getData(useParams) {
                // console.log(useParams,'useParams');
                this.envTable = useParams.env.map(item => {
                    return {
                        title: this.tableVal(item.envId, this.env),
                        name: item.envId + '',
                        content: [...item.param],
                        server: useParams.server.filter(i => +i.env === item.envId)
                    }
                })
            },

            // 根据数据字典取值
            tableVal(value, arr) {
                if(!arr) return '无'
                if(arr && arr.length == 0) return "无"
                let res = arr.filter(item => item.default == value)
                let str = ""
                if(!res.length) {
                    str =  "无"
                }else {
                    str = res[0].cname
                }
                return str
            },

            // 删除某一项
            handleDel(index, rows) {
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    })
                        .then(() => {
                            rows.splice(index, 1)
                            this.serviceTag=true
                            this.$message.success('删除成功!')
                        })
                        .catch(() => this.$message.info('已取消删除'));
            },

            // 更改数据
            changeData(form, ind) {
                let envList = this.envTable.filter(item => item.name === ind)
                let paramList = envList[0].content.filter(item => item.key === form.key)
                if (paramList.length) {
                    this.envTable = this.envTable.map(item => {
                        if (ind === item.name) {
                            return  {
                                ...item,
                                content: item.content.map(i => {
                                    if (i.key === form.key) {
                                        return {
                                            ...form
                                        }
                                    }else {
                                        return i
                                    }
                                })
                            }
                        }else {
                            return item
                        }
                    })
                } else {
                    let nevNum = 0
                    for(let item = 0; item < this.envTable.length; item++) {
                        if (this.envTable[item].name === ind) break
                        nevNum++
                    }
                    this.envTable[nevNum].content.unshift(form)
                }
            },

            // 点击存数据
            SubmitBtn() {
                let serverArr = []
                let envTable = this.envTable.map(item => {
                    item.server.forEach(i => {
                        serverArr.push(i)
                    })
                    return {
                        ...item,
                        envId: +item.name,
                        param: item.content
                    }
                })
                let params = {
                    ...this.useParams,
                    env: envTable,
                    server: serverArr,
                    serviceTag: this.serviceTag,
                    paramsTag: this.paramsTag
                }
                this.$store.commit("setParamEnv", params)
                this.$modal.close()
            },

            // 格式话内容
            formatter(row, column, cellValue, index) {
                if (cellValue === "1" | cellValue === "0") {
                    return cellValue === "1" ? 'true' : 'false'
                }else {
                    return cellValue
                }
            }
        }
    }
</script>
